<div class="grid-container">
  @if (orgList && orgList.length > 1) {
    <div class="grid-x margin-top">
      <div class="cell large-12 medium-12 small-12">
        Your profile is associated with multiple organizations.  Please select an organization to begin your session.
      </div>
      <div class="cell large-12">
        <select (change)="viewSelectedOrg($event.target.value)">
          <option></option>
          @for (org of orgList; track org) {
            <option [value]="org.orgId">
              {{ org.orgName }} (Owner # {{org.orgId}})
            </option>
          }
        </select>
      </div>
      <div class="cell large-12 margin-top">
        <span class="bold">Note: </span>If you wish to switch to a different one of your available organizations after this selection is made, you will need to click the "Logout" button above, sign back in to the application, and choose the appropriate organization when this page is presented.
      </div>
    </div>
  } @else {
    <div class="cell large-12 medium-12 small-12">
      <text-loader [run]="orgList === undefined || orgList.length === 0" [text]="'Loading profile.. please wait'" [tickType]="'.'" [interval]="1000"></text-loader>
      <text-loader [run]="orgList && orgList.length === 1" [text]="'Loading your dashboard.. please wait'" [tickType]="'.'" [interval]="1000"></text-loader>
    </div>
  }
</div>

